import React, { useEffect, useState } from 'react'
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useIsFocused, useNavigation, useRoute } from '@react-navigation/native'
import PropertySearch from '../../../components/maintainance/PropertySearch'

import { showErrorToast } from '../../tenants/tenantOnboarding/helpers'
import { archiveProject, getCatogoriesTypes, getFlow, getProjects, getRoomTypes, unarchiveProject } from '../../../redux/action/maintenance.actions'
import drawerHoc from '../../../components/drawerHOC/DrawerHOC'
import AddNewIssueModal from '../../../components/maintainance/AddNewIssueModal'
import IssueFormStep from '../../../components/maintainance/IssueFormStep'
import ActiveProjectTable from '../../../components/maintainance/ActiveProjectTable'
import CommonModal from '../../../components/maintainance/CommonModal'
import Active_project_openflow_id from './active_project_openflow_id'
import { Pagination } from '@mui/material'
import TableShimmer from '../../../components/maintainance/TableShimmer'
import EmptyState from '../../../components/maintainance/EmptyState'

const ActiveProjectScreen = ({ showCompletePage = true, onProjectUpdated, openflow_id_props, type_props, onViewProject }) => {
  const navigation = useNavigation()
  const dispatch = useDispatch()
  const route = useRoute()
  const routeType =
    route?.params?.type ??
    (route?.name === 'CompletedProject'
      ? 'completed'
      : route?.name === 'ArchivedProject'
        ? 'archived'
        : route?.name === 'ActiveProject'
          ? 'active'
          : undefined)
  const type = type_props ?? routeType ?? route?.params?.id ?? 'active'
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [showCompleteProjectModal, setShowCompleteProjectModal] = useState(false)
  const { projectList, projectListTotalCount } = useSelector(
    (state) => state.maintenance
  )
  const pageCount = Math.ceil(projectListTotalCount / 10)
  const getFlo = async () => {
    setOpenModal(false)
    try {
      setLoading(true)
      await dispatch(
        getProjects({
          offset: (page - 1),
          limit: pageSize,
          sortBy: 'date_opened',
          sortOrder: 'DESC',
          type: type
        })
      )
    } catch (e) {
      showErrorToast('Failed to fetch properties')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    dispatch(getRoomTypes())
    dispatch(getCatogoriesTypes())
  }, [type])
  const focus = useIsFocused();

  useEffect(() => {
    if (!focus) {
      return
    }

    console.log("useEffectrouteType",type)
    getFlo()
  }, [page, pageSize, focus, type])

  const handleView = (flow) => {
    if (onViewProject) {
      onViewProject(flow)
      return
    }

    if (openflow_id_props) {
      setSelectedProjectId(flow?.open_flow_maintenance_project_id)
    } else {
      if (type == "completed") {

        navigation.navigate('CompletedProjects', {
          id: flow?.open_flow_maintenance_project_id,
          type: "completed"
        })
      } else if (type == "archived") {

        navigation.navigate('ArchivedProjects', {
          id: flow?.open_flow_maintenance_project_id,
          type: "archived"
        })
      } else
        navigation.navigate('ActiveProjects', {
          id: flow?.open_flow_maintenance_project_id
        })
    }

  }

  if (selectedProjectId && openflow_id_props) {
    return <Active_project_openflow_id
      onBack={(datatype) => {
        setSelectedProjectId(null)
        if (datatype == "completed") {
          onProjectUpdated()
        }
      }
      }
      type_props={type}
      project_id={selectedProjectId}
    />
  }
  const handleProjectArchive = async (id) => {

    if (type == "archived") {
      const result = await dispatch(unarchiveProject({ id: Number(id), status: 'completed' }, type))

    } else {
      const result = await dispatch(archiveProject({ id: Number(id), status: 'completed' }, type))
    }

    setShowCompleteProjectModal(false)

  }
  const showArchivePopUp = async (obj) => {
    setShowCompleteProjectModal(obj.open_flow_maintenance_project_id)

  }
  const handlePageChanges = (event, value) => {
    setPage(value)
  }
  return (
    <View style={styles.container}>



      {loading ? (
        <TableShimmer rows={6} />
      ) : projectList?.length === 0 ? (

        <EmptyState
          title="No Projects Found"
          subText={
            type === "archived"
              ? "There are no archived projects available at the moment."
              : type === "completed"
                ? "There are no completed projects yet."
                : "There are currently no active maintenance projects."
          }
        />
      ) : (
        <>
          <ActiveProjectTable
            type={type}
            flos={projectList}
            onArchive={showArchivePopUp}
            onView={handleView}
            refresh={getFlo}
            onAdd={() => setOpenModal(true)}
          />

          <Pagination
            style={{ alignSelf: "center", marginTop: 10 }}
            count={pageCount}
            page={page}
            onChange={handlePageChanges}
            color="primary"
          />
        </>
      )}

      {openModal ? <AddNewIssueModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onIssueAdded={getFlo}
        refresh={getFlo}
      /> : null}

      <CommonModal
        visible={showCompleteProjectModal}
        heading="Are you sure?"
        subheading={type == "archived" ? "Are you sure, You want to unarchive this project?" : "Are you sure, You want to archive this project?"}
        yesText={type == "archived" ? "Yes, Unarchive" : "Yes, Archive"}
        noText="Cancel"
        onNo={() => setShowCompleteProjectModal(false)}
        onYes={() => handleProjectArchive(showCompleteProjectModal)}
      />
    </View>
  )
}
const WrappedComponent = drawerHoc({
  Component: ActiveProjectScreen,
  showBackButton: true,
  customWidth: "70%",
})




export default function ExportComponent(props: any) {
  // If showCompletePage is false → don't use drawerHoc
  if (props?.showCompletePage === false) {
    return <ActiveProjectScreen {...props} />
  }

  // Otherwise use drawer HOC
  return <WrappedComponent {...props} />
}
const styles = StyleSheet.create({
  container: { flex: 1, },
  title: { fontSize: 20, fontWeight: '700' },
  subtitle: { fontSize: 14, marginBottom: 20 },
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
  },

  emptyIcon: {
    fontSize: 60,
    marginBottom: 10,
  },

  emptyTitle: {
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 8,
  },

  emptySubTitle: {
    fontSize: 14,
    color: "#777",
    textAlign: "center",
  },
})
